<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="loginTitle"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Iniciar sesión
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <v-img src="@/assets/logo_multisensores_Horizontal_Dark2.png" />
            <base-material-alert
              v-model="showErrorMessage"
              color="error"
              dark
              dismissible
            >
              {{ errorLogin }}
            </base-material-alert>
            <validation-observer
              v-slot="{ handleSubmit }"
            >
              <form @submit.prevent="handleSubmit(login)">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:250"
                  name="credentials.username"
                >
                  <v-text-field
                    v-model="credentials.data.username"
                    color="loginPlaceHolder"
                    :label="$t('user-name')"
                    prepend-icon="mdi-email"
                    :error-messages="errors"
                  />
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:30"
                  name="credentials.password"
                >
                  <v-text-field
                    v-model="credentials.data.password"
                    class="mb-8"
                    color="loginPlaceHolder"
                    :label="$t('password')"
                    prepend-icon="mdi-lock-outline"
                    type="password"
                    :error-messages="errors"
                  />
                </validation-provider>

                <pages-btn
                  large
                  color=""
                  depressed
                  :loading="loading"
                  class="v-btn--text btn-login-text"
                  type="submit"
                >
                  Ingresar
                </pages-btn>
              </form>
            </validation-observer>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>
<style scoped>
.btn-login-text{
  color: #023A66;
  caret-color: #023A66;
}
.v-image_image{
  background-color: red !important;
}
</style>
<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const userRespository = repositoryFactory.get('users')

  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    data: () => ({
      credentials: {
        data: {
          username: '',
          password: '',
        },
      },
      showErrorMessage: false,
      errorLogin: '',
      loading: false,
    }),
    methods: {
      login () {
        var self = this
        self.loading = true
        userRespository.token(self.credentials).then(response => {
          if (response.data.isValid) {
            this.$store.commit('LOGIN', { user: response.data.data.user, jwtToken: response.data.data.token })
            self.$router.push('/')
          } else {
            self.showErrorMessage = true
            self.loading = false
            self.errorLogin = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 401) {
            self.errorLogin = self.$t('invalid-credentials')
          } else {
            self.errorLogin = err
          }
          self.loading = false
        })
      },
    },
  }
</script>
